export default __webpack_public_path__ + "static/media/ic-announcement.94ae047a.svg";